import React, { useMemo } from 'react';
import { Flex, FormControl } from '@chakra-ui/react';
import SdgHeaderCard from './SdgHeaderCard';
import { FormData } from './SdgQuiz';
import { QuestionFormItem } from './QuestionFormItem';
import contentJson from '../utils/content.json';
import { QuizBtn } from './QuizBtn';
import { SkipSdg } from './SkipSdg';
import { Relevance } from './Relevance';
import {
  calculatePercentage,
  countAnswersPoints,
  countFilledSdgs,
  countSdgs,
  countTotalQuestions,
  useResponsive,
} from '../utils';

type QuestionsFormProps = {
  sdgNumber: number;
  data: any;

  updateFields: (fields: Partial<FormData>) => void;
  handleNext: () => void;
  handleBack: () => void;
};

export const QuestionsForm = ({
  sdgNumber,
  data,

  updateFields,
  handleNext,
  handleBack,
}: QuestionsFormProps) => {
  const content: any = contentJson;
  const currentContent = content[`sdg${sdgNumber}`].questions;

  const isMobileScreen = useResponsive();

  const numberOfSdgs = useMemo(() => countSdgs(content), [content]);

  const totalQuestionsCount = useMemo(
    () => countTotalQuestions(currentContent),
    [currentContent],
  );

  const numberOfFilledSdgs = countFilledSdgs(data, sdgNumber);

  const areAllFieldsFilledIn = numberOfFilledSdgs === totalQuestionsCount;

  const answersPoints = countAnswersPoints(data, sdgNumber);

  const percentage = areAllFieldsFilledIn
    ? calculatePercentage(answersPoints, totalQuestionsCount)
    : 0;

  return (
    <Flex flexDir="column">
      <SdgHeaderCard
        data={data}
        sdgNumber={sdgNumber}
        updateFields={updateFields}
        handleNext={handleNext}
      />

      <FormControl display="flex" flexDir="column" justifyContent="center">
        {Object.keys(currentContent).map((questionType) => (
          <QuestionFormItem
            data={data}
            key={questionType}
            sdgNumber={sdgNumber}
            sdgType={questionType}
            updateFields={updateFields}
          />
        ))}
      </FormControl>

      {areAllFieldsFilledIn && <Relevance percentage={percentage} />}

      <Flex
        w="100%"
        justifyContent={sdgNumber === 1 ? 'center' : 'space-between'}
      >
        {!isMobileScreen && sdgNumber > 1 && (
          <QuizBtn onClick={handleBack}>Back to SDG {sdgNumber - 1}</QuizBtn>
        )}
        {sdgNumber < numberOfSdgs ? (
          <QuizBtn onClick={handleNext} disabled={!areAllFieldsFilledIn}>
            Continue to SDG {sdgNumber + 1}
          </QuizBtn>
        ) : (
          <QuizBtn onClick={handleNext} disabled={!areAllFieldsFilledIn}>
            Finish
          </QuizBtn>
        )}
      </Flex>

      <Flex alignSelf={isMobileScreen ? 'center' : 'end'} mb={5}>
        <SkipSdg
          data={data}
          sdgNumber={sdgNumber}
          updateFields={updateFields}
          handleNext={handleNext}
        />
      </Flex>
    </Flex>
  );
};
